"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.keyframes = exports.css = void 0;
var styledComponents = require("styled-components");
var css = styledComponents.css, styled = styledComponents.default, keyframes = styledComponents.keyframes;
exports.css = css;
exports.keyframes = keyframes;
exports.default = styled;
//# sourceMappingURL=index.js.map